import type { AllTranslationKeys } from '@@fire-base/i18n'
import { getTranslateFnOrNull, setTranslateFn } from '../../i18n/i18n.accessor'

/**
 * Wrapper composable for the i18n translation function.
 * Provides type safety for translation keys.
 *
 * Works in any context (component setup, Pinia stores, composables)
 * because it lazily captures the translate function from the Nuxt app's
 * i18n instance, rather than requiring a Vue component instance.
 */
export function useTranslate() {
  let t = getTranslateFnOrNull()

  if (!t) {
    const { $i18n } = useNuxtApp()
    t = (key: string, args?: Record<string, unknown>) => {
      return args ? $i18n.t(key, args) : $i18n.t(key)
    }
    setTranslateFn(t)
  }

  return (key: AllTranslationKeys, args?: Record<string, unknown>): string => {
    return t(key, args)
  }
}
